import { render } from "./ProductPriceList.vue?vue&type=template&id=0f6d3ce5&scoped=true&ts=true"
import script from "./ProductPriceList.vue?vue&type=script&lang=ts"
export * from "./ProductPriceList.vue?vue&type=script&lang=ts"

import "./ProductPriceList.vue?vue&type=style&index=0&id=0f6d3ce5&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/ClientApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6d3ce5"]])

export default __exports__